<template>
  <div class="winners-page">
    <div class="container">
      <div class="sidebar">
        <h2 class="sidebar-title">管理菜单</h2>
        <ul class="sidebar-menu">
          <li :class="{ active: activeTab === 'winners' }" @click="activeTab = 'winners'">
            中奖记录管理
          </li>
          <li :class="{ active: activeTab === 'participants' }" @click="activeTab = 'participants'">
            参与人员管理
          </li>
        </ul>
      </div>

      <div class="main-content">
        <h1 class="page-title">{{ activeTab === 'winners' ? '中奖名单' : '参与人员' }}</h1>

        <!-- 搜索和筛选 -->
        <div class="search-section">
          <div class="search-form">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="姓名">
                <el-input v-model="searchForm.name" placeholder="请输入姓名" />
              </el-form-item>
              <el-form-item label="门店">
                <el-input v-model="searchForm.store" placeholder="请输入门店" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
                <el-button v-if="activeTab === 'winners'" type="success" @click="exportWinners">导出</el-button>
                <el-button v-if="activeTab === 'winners'" type="danger" @click="clearWinners">清除中奖人员</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 中奖名单表格 -->
        <div v-if="activeTab === 'winners'" class="table-section">
          <el-table :data="winnersList" style="width: 100%" stripe>
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="name" label="姓名" width="180" />
            <el-table-column prop="phone" label="手机号" width="180" />
            <el-table-column prop="store" label="门店" width="180" />
            <el-table-column label="奖品" width="180">
              <template slot-scope="scope">
                {{ scope.row.prize ? scope.row.prize.name : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="奖品等级" width="100">
              <template slot-scope="scope">
                {{ scope.row.prize ? scope.row.prize.level : '-' }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 参与人员表格 -->
        <div v-else-if="activeTab === 'participants'" class="table-section">
          <el-table :data="participantsList" style="width: 100%" stripe>
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="name" label="姓名" width="180" />
            <el-table-column prop="phone" label="手机号" width="180" />
            <el-table-column prop="store" label="门店" width="180" />
            <el-table-column prop="isWinner" label="是否中奖" width="100">
              <template slot-scope="scope">
                {{ scope.row.isWinner === 1 ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="报名时间" width="200" />
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
            :current-page="currentPage" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'WinnersList',
  data() {
    return {
      activeTab: 'winners',
      winnersList: [],
      participantsList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        name: '',
        store: ''
      },
      loading: false
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.activeTab === 'winners') {
        await this.fetchWinners();
      } else {
        await this.fetchParticipants();
      }
    },

    async fetchWinners() {
      this.loading = true;
      try {
        const response = await request.get('/api/store/winners', {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            name: this.searchForm.name,
            store: this.searchForm.store
          }
        });

        if (response.data.code === 200) {
          this.winnersList = response.data.data.records;
          this.total = response.data.data.total;
        }
      } catch (error) {
        console.error('获取中奖名单失败:', error);
        this.$message.error('获取中奖名单失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    async fetchParticipants() {
      this.loading = true;
      try {
        const response = await request.get('/api/store/participants', {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            name: this.searchForm.name,
            store: this.searchForm.store
          }
        });

        if (response.data.code === 200) {
          this.participantsList = response.data.data.records;
          this.total = response.data.data.total;
        }
      } catch (error) {
        console.error('获取参与人员失败:', error);
        this.$message.error('获取参与人员失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    search() {
      this.currentPage = 1;
      this.fetchData();
    },

    resetSearch() {
      this.searchForm = {
        name: '',
        store: ''
      };
      this.currentPage = 1;
      this.fetchData();
    },

    async exportWinners() {
      try {
        const response = await request.get('/api/store/export', {
          params: {
            name: this.searchForm.name,
            store: this.searchForm.store
          },
          responseType: 'blob'
        });

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `中奖名单_${new Date().getTime()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },

    async clearWinners() {
      try {
        const response = await request.post('/api/store/batchCancel', []);
        if (response.data.code === 200) {
          this.$message.success('清除中奖人员成功');
          // 重新获取中奖名单
          this.fetchData();
        } else {
          this.$message.error('清除失败：' + response.data.msg);
        }
      } catch (error) {
        console.error('清除中奖人员失败:', error);
        this.$message.error('清除失败，请稍后重试');
      }
    }
  },
  watch: {
    activeTab() {
      this.currentPage = 1;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.winners-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  min-height: 800px;
}

/* 侧边栏样式 */
.sidebar {
  width: 200px;
  background: #1e3c72;
  color: white;
  padding: 20px;
  border-radius: 10px 0 0 10px;
}

.sidebar-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu li {
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sidebar-menu li:hover {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-menu li.active {
  background: #2a5298;
  font-weight: bold;
}

/* 主内容区域 */
.main-content {
  flex: 1;
  padding: 30px;
  border-radius: 0 10px 10px 0;
}

.page-title {
  text-align: center;
  color: #1e3c72;
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: bold;
}

.search-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.table-section {
  margin-bottom: 30px;
}

.pagination-section {
  text-align: right;
}

/* 表格样式 */
el-table {
  border-radius: 8px;
  overflow: hidden;
}

el-table th {
  background-color: #1e3c72 !important;
  color: white !important;
  font-weight: bold;
}

/* 按钮样式 */
el-button {
  margin-right: 10px;
}
</style>